import React, { FunctionComponent, useState, useCallback } from 'react';
import MyAccountContainer from '../../../../../common/components/myAccount/MyAccountContainer';
import currentDealSelectors from '../../../../store/selectors/currentDealSelectors';
import { IButtonClickAction } from '../../../presentational/actionButtons/ActionButtons';
import Save from '../../../presentational/actionButtons/customiseSave/Save';
import { useSelector } from 'react-redux';
import IActionButtonProps from '../IActionButtonProps';

const PlatformSave: FunctionComponent<IActionButtonProps> = ({ config }) => {
  const [isLoginModalOpen, setLoginModalOpen] = useState<boolean>(false);

  const currentDeal = useSelector(currentDealSelectors.getCurrentDeal);
  const isDisabled = currentDeal === null;

  const onClick: IButtonClickAction = useCallback(() => {
    setLoginModalOpen(true);
  }, []);

  return (
    <>
      <Save onClick={onClick} disabled={isDisabled || config.disabled} />
      {!isDisabled && isLoginModalOpen && (
        <MyAccountContainer isModalOpen={isLoginModalOpen} toggleModal={setLoginModalOpen} />
      )}
    </>
  );
};

export default PlatformSave;
